import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEdgeSlideIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M4 4v16M20 4v16M4 12h16" }), /* @__PURE__ */ _jsx("path", {
		d: "m10 8 2-3 2 3M10 16l2 3 2-3",
		opacity: .5
	})]
});
export default SvgEdgeSlideIcon;
